import { useWorkspaceCopy } from "./workspaceCatalog";
import { localeForFormatting } from "./preparedLocales";
import { formatMessage, type MessageValues } from "./catalogUtils";

const en = {
  riskByProfile: "Risk index by professional or community profile in {place}.",
  countryRisk: "{country}, risk {risk}",
  countryUnavailable: "{country}, insufficient public data",
  riskScale: "{risk} / {total}",
  previousPeriod: "{trend} vs previous period",
  likelihood: "{percent} likelihood · {confidence}",
  updated: "Last updated {date}",
};
const fa: Record<keyof typeof en, string> = {
  riskByProfile: "شاخص خطر بر پایهٔ گروه حرفه‌ای یا اجتماعی در {place}.",
  countryRisk: "{country}، شاخص خطر {risk}",
  countryUnavailable: "{country}، دادهٔ عمومی کافی نیست",
  riskScale: "{risk} از {total}",
  previousPeriod: "{trend} در مقایسه با دورهٔ قبل",
  likelihood: "احتمال {percent} · {confidence}",
  updated: "آخرین به‌روزرسانی {date}",
};
export function usePublicPagePresentation() {
  const { locale } = useWorkspaceCopy();
  const languageTag = localeForFormatting(locale);
  return {
    t: (key: keyof typeof en, values?: MessageValues) => formatMessage((locale === "fa" ? fa : en)[key], values),
    number: (value: number, options?: Intl.NumberFormatOptions) => new Intl.NumberFormat(languageTag, options).format(value),
    date: (value: string) => new Intl.DateTimeFormat(languageTag, { dateStyle: "long", timeZone: "UTC" }).format(new Date(value)),
  };
}
